module.exports = __webpack_public_path__ + "img/icon_1_29.b1ba7f6d.png";